module.exports = __webpack_public_path__ + "static/img/logo.ac56e1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 7Otq
// module chunks = 1